export const ACTIONS = {
  SET_THEME: "SET_THEME",

  SET_PLAYING: "SET_PLAYING",
  SET_SONG: "SET_SONG",
  SET_VOLUME: "SET_VOLUME",

  SET_HOVERED: "SET_HOVERED",
  SELECT_OBJECT: "SELECT_OBJECT",

  OPEN_DRAWER: "OPEN_DRAWER",
  CLOSE_DRAWER: "CLOSE_DRAWER",
  SET_DRAWER_CONTENT: "SET_DRAWER_CONTENT",
};
